import request from './request'

// 安心日保 当前投保人员-分页查询
export function queryStaffRecordListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insureDailyHandle/queryPageList', { params: data })
}

// 安心日保 根据 派遣单位id serveCompanyId or 保司编码 insureCompany  导出当前投保人员
export function getAxServeCompanyIdApi(id: any,type): Promise<any> {
  if(type == 'plan'){
    return request.get(`/isNew---/web/pc/pay/insureDailyHandle/exportByServeCompany?insureCompany=${id}`, {
      responseType: 'blob'
    })
  }
  if(type == 'company'){
    return request.get(`/isNew---/web/pc/pay/insureDailyHandle/exportByServeCompany?serveCompanyId=${id}`, {
      responseType: 'blob'
    })
  }
}
// 安心保 根据 派遣单位id serveCompanyId or 保司编码 insureCompany  导出当前投保人员
export function getServeCompanyIdApi(id: any,type): Promise<any> {
  if(type == 'plan'){
    return request.get(`/isNew---/web/pc/pay/insurePeriodStaffRecord/exportByServeCompany?insureCompany=${id}`, {
      responseType: 'blob'
    })
  }
  if(type == 'company'){
    return request.get(`/isNew---/web/pc/pay/insurePeriodStaffRecord/exportByServeCompany?serveCompanyId=${id}`, {
      responseType: 'blob'
    })
  }
}


// 查询出险人员列表-安心日保
export function queryOutDangerStaffDailyList(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insureDailyHandle/queryOutDangerStaffList', { params: data })
}
// 撤销报案
export function revokeReportCaseApi(data: any): Promise<any> {
  return request.put(`/isNew---/web/pc/pay/insurePeriodReportCase/revokeReportCase?reportCaseId=${data.reportCaseId}`)
}
// 获取安心日保首页 实时数据
export function getRealTimeDataApi(data: any): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insureDailyStatistics/queryPremiumAndInsureNum`, { params: data })
}

// 获取安心日保首页 风险分析
export function getPremiumAndInsureNumApi(): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insureDailyStatistics/queryCompanyClaimRisk`)
}
// 安心保首页 echarts
export function getPremiumAndInsureNumEchartsApi(data: any): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insureDailyStatistics/queryPremiumAndInsureNumTrend`, { params: data })
}

// 加保获取方案列表
export function getInsureEnsurePlanApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pay/insureEnsurePlan/list', { params: data })
}

// 查询公司安心日保余额
export function getAxDailyBalanceApi(data: any): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/openEnsure/queryAxDailyBalance`, { params: data })
}

// 安心日保-操作记录
export function getAxOperateRecordListApi(data: any): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insureDailyPeriodOperateRecord/queryPageList`, { params: data })
}

// 根据操作记录id查询投保记录列表
export function getAxOperateRecordIdListApi(data: any): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insureDailyHandle/queryPageByOperateRecordId`, { params: data })
}

// 根据操作记录id导出投保记录列表
export function getAxOperateRecordIdApi(id: any): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insureDailyHandle/exportByOperateRecordId?operateRecordId=${id}`, {
    responseType: 'blob'
  })
}

//  获取充值权限
export function getInsureBalanceAxPermission(): Promise<any> {
    return request.get('/wesure/wesure-insure-record/wesure-data-port-daily')
}

// 保司列表
export function getInsureCompanyAxApi(data: any): Promise<any> {
    return request.get('/isNew---/web/pay/insureCompany/list', { params: data })
}


// 获取 保费记录
export function getInsureDailyFeeListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/pcPayInsureDailyFeeController/list', { params: data })
}
// 根据保费记录导出
export function getInsureDailyFeeExportApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/pcPayInsureDailyFeeController/export', {
    params: data,
    responseType: 'blob'
  })
}

export function getInsureDailyStaffExportApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/pcPayInsureDailyFeeController/export/dailyStaff', data, {
    responseType: 'blob'
  })
}

// 获取当前项目id
export function getNowProjectIdApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pay/insureEnsureProject/myProject', {
    params: data
  })
}

// 创建项目
export function addEnsureProject(data: any): Promise<any> {
  return request.post('/isNew---/web/pay/insureEnsureProject/createProject',data)
}
// 获取项目列表
export function getEnsureProjectListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pay/insureEnsureProject/list', { params: data })
}
// 切换项目
export function switchEnsureProjectApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pay/insureEnsureProject/switch',data)
}

// 安心日保 转 安心保
export function insuranceAxTransfer(data: any): Promise<any> {
    return request.post('/rest/company/transfer-to-period', data)
}
// 安心日保 工对工充值 接口
export function insuranceAxRecharge(data: any): Promise<any> {
  return request.post('/rest/company/daily-recharge', data, {
    headers: {
        allResponse: 'allResponse'
    }
  })
}

// 在线选择 获取历史员工列表
export function getDailyHandleStaffListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insureDailyHandle/queryStaffList', { params: data })
}

// 提交加保名单 前校验的金额
export function checkAddEnsureApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/pcPayInsureDailyHandleController/checkAddEnsure',data)
}

//
export function addEnsureDailyApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/pcPayInsureDailyHandleController/ensureDaily',data)
}

//账单明细 列表接口 statusList; 1=已充值 3=提现, 4=转出, 5=转入"
// export function getDailyAccountBalanceListApi(data: any): Promise<any> {
//   return request.get('/api/v1/pay/period-insur/account-balance/dailyList', { params: data })
// }

// 获取账单明细 充值记录分页
export function getInsureBalanceAxRechargeApi(params: any): Promise<any> {
     return request.get('/rest/insure/insure-info/dailyList', {
        params
     })
}

// 获派遣单位列表不分页的接口
export function getServeCompanyListApi(params: {
    insureType: 2 | 8
}): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodServeCompany/queryList', {
    params
  })
}

